module.exports = __webpack_public_path__ + "img/product-7-mobilezhuanye.09bc5d3a.png";